import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { isValidRegtankUrl } from "../Utils/urlValidation";
import useGetRegtankIndOnboardingLink from "./useGetRegtankIndOnboarding";

/**
 * Hook to handle Regtank onboarding click and URL management
 */
export const useRegtankOnboardingClick = (
  token: string,
  existingUrl?: string
) => {
  const getRegtankIndOnboardingMutation = useGetRegtankIndOnboardingLink();
  const [isLoadingRegtank, setIsLoadingRegtank] = useState(false);
  const [regtankOnboardingUrl, setRegtankOnboardingUrl] = useState<string>(
    existingUrl || ""
  );

  const handleRegtankClick = useCallback(() => {
    if (regtankOnboardingUrl) {
      if (!isValidRegtankUrl(regtankOnboardingUrl)) {
        toast.error("Invalid verification URL. Please contact support.");
        return;
      }
      window.open(regtankOnboardingUrl, "_self");
    } else {
      setIsLoadingRegtank(true);
      getRegtankIndOnboardingMutation.mutate(
        { token },
        {
          onSuccess: (data) => {
            if (!isValidRegtankUrl(data)) {
              toast.error("Invalid verification URL. Please contact support.");
              setIsLoadingRegtank(false);
              return;
            }
            setIsLoadingRegtank(false);
            window.open(data, "_self");
          },
          onError: (e) => {
            setIsLoadingRegtank(false);
            toast.error((e as Error).message);
          },
        }
      );
    }
  }, [regtankOnboardingUrl, token, getRegtankIndOnboardingMutation]);

  return {
    isLoadingRegtank,
    regtankOnboardingUrl,
    setRegtankOnboardingUrl,
    handleRegtankClick,
  };
};
